<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="dialogBtn" rounded dark class="mb-2 red--text" v-bind="attrs" v-on="on">Edit</v-btn>
    </template>
    <v-card>
      <v-toolbar color="secondary">
        <v-toolbar-title>
          Edit Personal Information
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <span class="headline"></span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            label="Firstname"
            name="firstname"
            prepend-icon="mdi-account"
            type="text"
            v-model="person.firstname"
            dense
            rounded
            outlined
            required
          />
          <v-text-field
            label="Surname"
            name="surname"
            prepend-icon="mdi-account"
            type="text"
            v-model="person.surname"
            required
            dense
            rounded
            outlined
          />
          <v-text-field
            label="Also know as:"
            name="Know_as"
            prepend-icon="mdi-account"
            type="text"
            v-model="person.known_as"
            dense
            rounded
            outlined
          />
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Date of Birth"
                name="data_of_birth"
                prepend-icon="mdi-calendar-month"
                type="date"
                v-model="person.date_of_birth"
                dense
                rounded
                outlined
              />
            </v-col>
            <v-col>
              <v-select
                :items="gender"
                label="Gender"
                item-text="name"
                item-value="id"
                v-model="person.gender"
                dense
                rounded
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-spacer>Phone Numbers</v-spacer>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Phone (Home)"
                name="data_of_birth"
                prepend-icon="mdi-account"
                type="text"
                dense
                rounded
                outlined
                v-model="person.phone_home"
              />
            </v-col>
            <v-col>
              <v-text-field
                label="Phone (Mobile)"
                name="data_of_birth"
                prepend-icon="mdi-account"
                type="text"
                dense
                rounded
                outlined
                v-model="person.phone_mobile"
              />
            </v-col>
          </v-row>
          <v-spacer>Address</v-spacer>
          <v-textarea
            label="Street"
            name="street"
            prepend-icon="mdi-directions-fork"
            type="text"
            dense
            rounded
            outlined
            rows="2"
            v-model="address.street"
          />
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="City"
                name="data_of_birth"
                prepend-icon="mdi-account"
                type="text"
                dense
                outlined
                rounded
                v-model="address.city"
              />
            </v-col>
            <v-col>
              <v-text-field
                label="Post Code"
                name="post_code"
                prepend-icon="mdi-account"
                type="text"
                dense
                outlined
                rounded
                v-model="address.post_code"
              />
            </v-col>
          </v-row>
          <v-spacer>Medical Details</v-spacer>
          <v-text-field
            label="NHS Number"
            name="Nhs_number"
            prepend-icon="mdi-counter"
            rounded
            dense
            outlined
            type="text"
            v-model="person.nhs_number"
          />
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                :items="uLanguages"
                label="Language"
                item-text="language"
                item-value="id"
                v-model="person.language_id"
                outlined
                dense
                rounded
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-autocomplete
                :items="uReligion"
                label="Religion"
                item-text="religion"
                item-value="id"
                v-model="person.religion_id"
                outlined
                dense
                rounded
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                :items="bloodGroups"
                label="Blood Group"
                item-text="group"
                item-value="id"
                v-model="person.blood_group"
                outlined
                rounded
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                :items="organDonor"
                label="Organ Donor"
                item-text="text"
                item-value="value"
                v-model="person.organ_donor"
                outlined
                rounded
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                :items="dnr"
                label="Do not resuscitate"
                item-text="text"
                item-value="value"
                v-model="person.dnr"
                outlined
                rounded
                dense
                @change="dnrChange()"
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="covid"
                label="Covid Status"
                item-text="value"
                item-value="value"
                v-model="person.covid_status"
                outlined
                dense
                rounded
              ></v-select>
            </v-col>
          </v-row>
          <v-textarea
            name="input-7-1"
            label="Notes"
            v-model="person.notes"
            outlined
            hint="Some important information about your health"
          ></v-textarea>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary darken-1" rounded @click="save">Save</v-btn>
        <v-btn color="secondary darken-1" text  @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
    <DnrConsent ref="dnrc"/>
  </v-dialog>
</template>

<script>
import DnrConsent from "./DnrConsent"
import { mapGetters } from "vuex";
export default {
data: () => ({
    dialog: false,
    valid: true,
    title: "Personal Information",
    btnTitle: "Edit",
    profile: {
      firstname: "",
      surname: "",
      date_of_birth: ""
    },
    person: {
      language_id: "",
      gender: "",
      religion_id: "",
      phone_mobile: "",
      phone_home: "",
      known_as: "",
      nhs_number: "",
      date_of_birth: "",
      blood_group: "",
      organ_donor: "",
      covid_status: "",
      notes: "",
      surname: "",
      firstname: "",
      dnr: ""
    },
    select: {
      gender: "",
      religion: "",
      language: ""
    },
    privacy: {
      language: "",
      religion: "",
      surname: "",
      firstname: "",
      phone_mobile: "",
      phone_home: "",
      known_as: "",
      nhsNumber: "",
      date_of_birth: "",
      blood_group: "",
      organ_donor: "",
      notes: "",
      dnr_pr: ""
    },
    address: {
      street: "",
      post_code: "",
      city: "",
      visibility: ""
    },
    gender: [
      { id: "m", name: "male" },
      { id: "f", name: "female" }
    ],
    covid: [
      { value: "Not vaccinated"},
      { value: "Vaccinated"},
    ],
    bloodGroups: [
      { id: "A+", group: "A+" },
      { id: "A-", group: "A-" },
      { id: "AB+", group: "AB+" },
      { id: "AB-", group: "AB-" },
      { id: "B+", group: "B+" },
      { id: "B-", group: "B-" },
      { id: "O+", group: "O+" },
      { id: "O-", group: "O-" }
    ],
    organDonor: [
      { text: "Yes", value: 1 },
      { text: "No", value: 0 }
    ],
    dnr: [
      { text: "Yes", value: 1 },
      { text: "No", value: 0 }
    ]
  }),
  watch: {
    dialog() {
      //
    }
  },
  methods: {
    deleteItem(item) {
      
      this.$store.dispatch("user/aDeleteProfile", item.id).then(res => {
        if (res) {
          //
        }
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        delete this.person.language;
        delete this.person.religion;
        delete this.person.created_at;
        delete this.person.updated_at
        delete this.address.updated_at
        delete this.address.id
        const updates = {
          patient: this.person,
          residence: this.address
        };
        delete updates.residence.updated_at
        this.$store.dispatch("personal/aUpdatePerson", updates).then(res => {
          if (res) {
            this.dialog = false;
          }
        });
      }
    },
    dnrChange() {
      if (this.person.dnr) {
        this.$refs.dnrc.openDialog()
      }
    }
  },
  computed: {
    ...mapGetters("personal", {
      patient: "gPatient",
      me: "gMe",
      addressed: "gAddress",
      editName: "gEditName",
      uLanguages: "gLanguages",
      uReligion: "gReligion"
    })
  },
  components:{
    DnrConsent
  },
  created() {
    this.$store.dispatch("personal/aPersonal").then(response => {
      if (response) {
        this.person = Object.assign({}, this.patient);
        this.address = Object.assign({}, this.addressed);
      }
    });
  }
}
</script>

<style>

</style>